import React from 'react';
import { Form } from 'react-bootstrap';
import { AppointmentState } from '../types';

/**
 * ServantAppointmentFormコンポーネント用のPropsです。
 * @interface ServantAppointmentFormProps
 */
interface ServantAppointmentFormProps {

  /**
   * 委任事項の索引
   * @type {number}
   * @memberof ServantAppointmentFormProps
   */
  appointmentIndex: number;

  /**
   * 委任事項（サブ）の索引
   * @type {number}
   * @memberof ServantAppointmentFormProps
   */
  servantAppointmentIndex: number;

  /**
   * 委任事項
   * @type {Appointment}
   * @memberof MasterAppointmentFormProps
   */
  appointment: AppointmentState;

  /**
   * チェック状態を設定する関数
   * @memberof DocumentTypeFormProps
   */
  onChange: (appointmentIndex: number, servantAppointmentIndex: number, isChecked: boolean) => void;
}

/**
 * 委任事項（サブ）フォームのコンポーネントです。
 * @param {number} props.appointmentIndex - 委任事項の索引
 * @param {number} props.servantAppointmentIndex - 委任事項（サブ）の索引
 * @param {Appointment} props.appointment - 委任事項
 * @param {function} props.onChange - チェック状態が変更されたときに呼ばれるコールバック関数
 * @returns {JSX.Element} - 委任事項（サブ）フォームのJSX要素
 */
const ServantAppointmentForm: React.FC<ServantAppointmentFormProps> = ({ appointmentIndex, servantAppointmentIndex, appointment, onChange }) => {

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const updatedIsChecked: boolean = event.target.checked;
    onChange(appointmentIndex, servantAppointmentIndex, updatedIsChecked);
  }

  return (
    <Form.Group controlId={`servantAppointment${appointment.appointmentId}`}>
      <Form.Check
        type="checkbox"
        label={appointment.label}
        value={appointment.value} 
        onChange={handleChange}
        checked={appointment.isChecked}
      />
    </Form.Group>
  );
}

export default ServantAppointmentForm;